import { render, staticRenderFns } from "./ZhiqiTongNew.vue?vue&type=template&id=2cde6372&scoped=true"
import script from "./ZhiqiTongNew.vue?vue&type=script&lang=js"
export * from "./ZhiqiTongNew.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTongNew.vue?vue&type=style&index=0&id=2cde6372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde6372",
  null
  
)

export default component.exports